import { z } from 'zod';

import { divisionWhatsappPhoneNumber } from '../Division/Division';

export const schemaWabaPhoneNumberAvailabilityPayload = z.object({
    phoneNumberId: divisionWhatsappPhoneNumber.shape.phoneNumberId,
});

export type Schema_WabaPhoneNumberAvailabilityPayload = z.infer<typeof schemaWabaPhoneNumberAvailabilityPayload>;
